import { Box, Stack } from "@mui/system";
import "moment/locale/fr";
import { AsSoonAsPossibleModel, SelectDateModel } from "./letter-models";
import moment from "moment/moment";
import { useEffect, useState } from "react";
import AutoScale from "../Utils/AutoScale";

export default function ResiliationLetter(props) {

  const {
    formFields,
    resiliationModel,
    containerId,
    address,
  } = props;

  const [infosToDisplay, setInfosToDisplay] = useState();

  const [currentAddress, setCurrentAddress] = useState();

  useEffect(() => {
    setInfosToDisplay(formFields);
  }, [formFields]);

  useEffect(() => {
    setCurrentAddress(address);
  }, [address]);

  return (
    <Stack
      width={{ lg: "653px", sm: "665px", xs: "300px" }}
      ml={{ lg: "25px", sm: "15px", xs: "10px" }}
    >
      <div
        className="container"
        style={{ boxShadow: "0px 0px 15px rgba(0, 51, 153, 0.1)", fontSize: "14px" }}
      >
        <AutoScale>
          <div
            id={containerId ? containerId : "resiliation-letter"}
            style={{
              height: "29.6cm",
              width: "20.9cm",
              fontSize: "14px",
              fontFamily: "Open Sans",
              textAlign: "left"
            }}
          >
            <Box
              sx={{
                padding: "1.5cm",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                alignContent: "center",
                backgroundColor: "white",
                height: 1,
                fontSize: "14px",
              }}
            >
              <Box
                sx={{
                  backgroundColor: "white",
                }}
              >
                {/* contact infos */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    padding: "0px",
                    gap: "3px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "flex-end",
                      color: "#000000",
                      fontWeight: 700,
                    }}
                  >
                    {infosToDisplay?.lastName} {infosToDisplay?.firstName}
                  </Box>
                  <Box
                    sx={{
                      color: "#000000",
                      fontWeight: 700,
                    }}
                  >
                    {infosToDisplay?.address}
                    <br />
                    {infosToDisplay?.additionalAddress}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "flex-end",
                      color: "#000000",
                      fontWeight: 700,
                    }}
                  >
                    {infosToDisplay?.postalCode} {infosToDisplay?.city}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "flex-end",
                      color: "#000000",
                    }}
                  >
                    E-mail :&nbsp;<b> {infosToDisplay?.user?.email}</b>
                  </Box>

                  {infosToDisplay?.clientNumber?.trim().length > 0 && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-end",
                        color: "#000000",
                      }}
                    >
                      Réf. client :&nbsp;
                      <b>{infosToDisplay?.clientNumber}</b>
                    </Box>
                  )}
                </Box>

                {/* address */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    gap: "3px",
                    mt: "20px",
                  }}
                >

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      textAlign: "right",
                    }}
                  >
                    {[1, 2, 3, 4, 5, 6].map((index) => {
                      return (
                        <Box key={index} sx={{ color: "#000000" }}>
                          {currentAddress != null &&
                            currentAddress[`addressLine${index}`] != null &&
                            currentAddress[`addressLine${index}`] !== "" && (
                              <>
                                {currentAddress[`addressLine${index}`]}
                                <br />
                              </>
                            )}
                        </Box>
                      );
                    })}
                    <Box
                      sx={{
                        display: "flex",
                        color: "#000000",
                        mt: "20px",
                      }}
                    >
                      le
                      &nbsp;{moment().format("L")}{" "}
                      à
                      &nbsp; <b> {infosToDisplay?.city}</b>
                    </Box>
                    <br />
                  </Box>
                </Box>

                {/* object message */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "14px",
                  }}
                >
                  {infosToDisplay?.effectiveNow === "true" || infosToDisplay?.effectiveNow === true ? (
                    <AsSoonAsPossibleModel
                      displayFullContent={true}
                      resiliationModelName={resiliationModel?.name}
                    />
                  ) : (
                    <SelectDateModel
                      displayFullContent={true}
                      resiliationDate={infosToDisplay?.date}
                      resiliationModelName={resiliationModel?.name}
                    />
                  )}
                </Box>
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  sx={{ marginTop: "40px" }}
                >
                  <Stack direction="column">
                    <Box
                      sx={{
                        position: "relative",
                        height: "70px",
                        width: "200px",
                      }}
                    >
                      <Box
                        sx={{
                          fontFamily: "Caveat",
                          fontSize: "1.5rem !important",
                          fontWeight: "700",
                        }}
                      >
                        {infosToDisplay?.firstName} {infosToDisplay?.lastName}
                      </Box>
                    </Box>
                  </Stack>
                </Stack>
              </Box>
            </Box>
          </div>
        </AutoScale>
      </div>
    </Stack>
  );
}
